// extracted by mini-css-extract-plugin
module.exports = {"toolbar":"styles_toolbar__1guTV","buttonsContainer":"styles_buttonsContainer__1vl1W"};